import React from 'react';
import DynamicFormWidget from './DynamicFormWidget';
import { Drawer, IconButton } from '@mui/material';
import { IDynamicFormDrawer } from './types';
import { useDynamicFormDrawerStyles } from './style';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '@components/loader/Loader';
import { MAIN_THEME } from '@styles';

const DynamicFormDrawer: React.FC<IDynamicFormDrawer> = (props) => {
  const { title, loading, isOpen, onClose } = props;
  const { classes } = useDynamicFormDrawerStyles();

  return (
    <Drawer
      open={isOpen}
      anchor={'bottom'}
      onClose={onClose}
      classes={{ paperAnchorBottom: classes.drawer }}
    >
      <header className={classes.drawerHeader}>
        <figure className={classes.sectionFigure} />
        <span className={classes.drawerHeaderTitle}>{title}</span>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ margin: '0 15px 0 0' }}
        >
          <CloseIcon sx={{ color: MAIN_THEME.color.white }} />
        </IconButton>
      </header>
      {loading ? (
        <div className={classes.loaderContainer}>
          <Loader />
        </div>
      ) : (
        <DynamicFormWidget {...props} />
      )}
    </Drawer>
  );
};

export default DynamicFormDrawer;
